/**
 * Remove valores null, undefined e string vazia do objeto de params para que não sejam enviados como query params.
 * Mantém números (incluindo 0), strings não vazias, booleanos (incluindo false) e arrays.
 */
export function stripNullishParams<T extends Record<string, unknown>>(
  params: T
): Partial<T> {
  if (params == null || typeof params !== "object") {
    return {};
  }
  return Object.fromEntries(
    Object.entries(params).filter(([, v]) => v != null && v !== "")
  ) as Partial<T>;
}
